import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import { T } from '@sm/intl';
import { useResponses } from '../../../Context';
import { OECSentiment } from '../../../types';
import { SentimentRow } from './SentimentRow';
export const COPY = {
  title: {
    id: 'OpenEndedCoding.SentimentStats.title',
    defaultMessage: 'Sentiment',
    description: '[Type: Header][Vis: med] - Header for sentiment stats'
  }
};
const SentimentStats = () => {
  const {
    saStats
  } = useResponses();
  const {
    positive: positiveCount,
    negative: negativeCount,
    neutral: neutralCount,
    undetected: undetectedCount
  } = saStats;
  const totalCount = positiveCount + negativeCount + neutralCount + undetectedCount;
  return _jsxs(Box, {
    children: [_jsx(Box, {
      mb: 5,
      children: _jsx(Typography, {
        component: "h5",
        variant: "cardTitle",
        weight: "medium",
        children: _jsx(T, {
          desc: COPY.title
        })
      })
    }), _jsxs(Box, {
      mr: 1,
      flexDirection: "column",
      children: [_jsx(Box, {
        children: _jsx(SentimentRow, {
          sentiment: OECSentiment.SM_POSITIVE,
          saCount: positiveCount,
          totalSaCounts: totalCount
        })
      }), _jsx(Box, {
        children: _jsx(SentimentRow, {
          sentiment: OECSentiment.SM_NEUTRAL,
          saCount: neutralCount,
          totalSaCounts: totalCount
        })
      }), _jsx(Box, {
        children: _jsx(SentimentRow, {
          sentiment: OECSentiment.SM_NEGATIVE,
          saCount: negativeCount,
          totalSaCounts: totalCount
        })
      }), _jsx(Box, {
        children: _jsx(SentimentRow, {
          sentiment: OECSentiment.SM_UNDETECTED,
          saCount: undetectedCount,
          totalSaCounts: totalCount
        })
      })]
    })]
  });
};
export default SentimentStats;